// extracted by mini-css-extract-plugin
module.exports = {"recent-item-wrapper":"RecentItem_recent-item-wrapper__1KSjM","recent-item":"RecentItem_recent-item__10R4c","centered":"RecentItem_centered__ZyEO8"};